import {AutogenLayoutSendSmsMessageSlideout} from "./autogen/AutogenLayoutSendSmsMessageSlideout";
import {
    Button, ChangeEvent, ClickEvent, DataSourceModeChangeEvent,
    LayoutProps, LookupModelSelectionEvent, Snackbar, Switch, Toast
} from "@mcleod/components";
import { Api, ModelRow, StringUtil } from "@mcleod/core";
import { SmsFieldsContainer } from "@mcleod/powerbroker";

interface SMSTemplate {
    order_number: string;
    street_addresses: string;
    schedule_arrival_times: string;
    contact_information: string;
    comments: string;
    reference_numbers: string;
    directions: string;
    directions_disclaimer: string;
    distance_between_stops: string;
    office_phone: string;
    office_cell: string;
    office_email: string;
    do_not_call_notice: string;
    city_state_zip: string;
    request_link: string;
    request_info_header:string;
}


interface SendSmsMessageLayoutProps extends LayoutProps {
    movementId: string;
    carrierId: string;
    messageText: string;
    orderId: string;
    driverName: string;
    messageId: string;
    deliveryMode: string;
    updateMessage: boolean;
    hours: string;
    recurrenceFrequency: string;
    recurrenceTermination: string;
    driverId: string;
    driverCell: string;
    recipientName: string;
}

export class SendSmsMessageSlideout extends AutogenLayoutSendSmsMessageSlideout {
    private _movementId: string;
    private _driverName:string;
    private _messageId:string;
    private _orderId: string;
    private _carrierId: string;
    private _messageText: string;
    private _includeStopDetails = false;
    private _includeArrivalTimes = false;
    private _includeContactInformation = false;
    private _includeCommentInformation = false;
    private _includeReferenceNumbers = false;
    private _includeDirections = false;
    private _includeDirectionsDisclaimer = false;
    private _includeDistanceBetweenStops = false;
    private _includeDistanceBetweenDirections = false;
    private _includeSenderOfficeNum = false;
    private _includeSenderCellNumber= false;
    private _includeSenderEmail = false;
    private _includeDoNotCall = false;
    private _isContact: boolean = false;

    constructor(props?: Partial<SendSmsMessageLayoutProps>) {
        super(props);
        this._movementId = props?.movementId;
        this._carrierId = props?.carrierId;
        this._messageText = props?.messageText;
        this._orderId = props?.orderId;
        this._driverName = props?.driverName;
        this._carrierId = props?.carrierId;
        this._messageId = props?.messageId;
    }


    public buttonSend = new Button({
        id: "sendButton",
        rowBreak: false,
        caption: "Send Message",
        borderWidth: 0,
        backgroundColor: "primary",
        onClick: (event: ClickEvent) => this.sendSmsMessage(),
        visible: false
    })

    public buttonUpdate = new Button({
        id: "updateButton",
        rowBreak: false,
        borderWidth: 0,
        backgroundColor: "primary",
        caption: "Update Message",
        onClick: (event: ClickEvent) => this.updateScheduledMessage(),
        visible: false,
        enabled:false
    })

    sourceCarrierDriverMessageAfterModeChange(event: DataSourceModeChangeEvent) {
        this.sourceCarrierDriverContacts.mode = event.newMode;
    }

    smsMessageTextOnChange(event: ChangeEvent) {
        const maxCharacters = 160;
        const charactersUsed = this.smsMessageText.text.length;
        let remainCharacters = maxCharacters - charactersUsed;
        let numOfText = Math.ceil(charactersUsed / maxCharacters);

        // If there are more than 1 text messages, reset the remaining characters.
        if (numOfText > 1) {
            numOfText = Math.ceil(charactersUsed / maxCharacters);
            remainCharacters = maxCharacters * numOfText - charactersUsed;
        }

        this.textboxCharacters.text = charactersUsed.toString();
        this.textboxCharactersRemaining.text = remainCharacters.toString();
        this.textboxNumofTextMessages.text = numOfText.toString();
    }

    switchStopNameOnChange(event: ChangeEvent) {
        this._includeStopDetails = this.switchStopName.checked;
        this.handleSwitchChangeAndUpdateSmsText(this._movementId,this._includeStopDetails,this._includeArrivalTimes,
            this._includeContactInformation,this._includeCommentInformation,this._includeReferenceNumbers,
            this._includeDirections,this._includeDirectionsDisclaimer,
            this._includeDistanceBetweenStops, this._includeDistanceBetweenDirections,this._includeSenderOfficeNum,
            this._includeSenderCellNumber,this._includeSenderEmail,this._includeDoNotCall);
    }


    switchSchedArrivalTimesOnChange(event: ChangeEvent) {
        this._includeArrivalTimes = this.switchSchedArrivalTimes.checked;
        this.handleSwitchChangeAndUpdateSmsText(this._movementId,this._includeStopDetails,this._includeArrivalTimes,
            this._includeContactInformation,this._includeCommentInformation,this._includeReferenceNumbers,
            this._includeDirections,this._includeDirectionsDisclaimer,
            this._includeDistanceBetweenStops, this._includeDistanceBetweenDirections,this._includeSenderOfficeNum,
            this._includeSenderCellNumber,this._includeSenderEmail,this._includeDoNotCall);
    }

    switchContactInfoOnChange(event: ChangeEvent) {
        this._includeContactInformation = this.switchContactInfo.checked;
        this.handleSwitchChangeAndUpdateSmsText(this._movementId,this._includeStopDetails,this._includeArrivalTimes,
            this._includeContactInformation,this._includeCommentInformation,this._includeReferenceNumbers,
            this._includeDirections,this._includeDirectionsDisclaimer,
            this._includeDistanceBetweenStops, this._includeDistanceBetweenDirections,this._includeSenderOfficeNum,
            this._includeSenderCellNumber,this._includeSenderEmail,this._includeDoNotCall);
    }

    switchCommentsOnChange(event: ChangeEvent) {
        this._includeCommentInformation = this.switchComments.checked;
        this.handleSwitchChangeAndUpdateSmsText(this._movementId,this._includeStopDetails,this._includeArrivalTimes,
            this._includeContactInformation,this._includeCommentInformation,this._includeReferenceNumbers,
            this._includeDirections,this._includeDirectionsDisclaimer,
            this._includeDistanceBetweenStops, this._includeDistanceBetweenDirections,this._includeSenderOfficeNum,
            this._includeSenderCellNumber,this._includeSenderEmail,this._includeDoNotCall);
    }

    switchReferenceNumbersOnChange(event: ChangeEvent) {
        this._includeReferenceNumbers = this.switchReferenceNumbers.checked;
        this.handleSwitchChangeAndUpdateSmsText(this._movementId,this._includeStopDetails,this._includeArrivalTimes,
            this._includeContactInformation,this._includeCommentInformation,this._includeReferenceNumbers,
            this._includeDirections,this._includeDirectionsDisclaimer,
            this._includeDistanceBetweenStops, this._includeDistanceBetweenDirections,this._includeSenderOfficeNum,
            this._includeSenderCellNumber,this._includeSenderEmail,this._includeDoNotCall);
    }

    switchDirectionsOnChange(event: ChangeEvent) {
        this._includeDirections = this.switchDirections.checked;
        this.handleSwitchChangeAndUpdateSmsText(this._movementId,this._includeStopDetails,this._includeArrivalTimes,
            this._includeContactInformation,this._includeCommentInformation,this._includeReferenceNumbers,
            this._includeDirections,this._includeDirectionsDisclaimer,
            this._includeDistanceBetweenStops, this._includeDistanceBetweenDirections,this._includeSenderOfficeNum,
            this._includeSenderCellNumber,this._includeSenderEmail,this._includeDoNotCall);
    }

    switchDirectionsDisclaimerOnChange(event: ChangeEvent) {
        this._includeDirectionsDisclaimer = this.switchDirectionsDisclaimer.checked;
        this.handleSwitchChangeAndUpdateSmsText(this._movementId,this._includeStopDetails,this._includeArrivalTimes,
            this._includeContactInformation,this._includeCommentInformation,this._includeReferenceNumbers,
            this._includeDirections,this._includeDirectionsDisclaimer,
            this._includeDistanceBetweenStops, this._includeDistanceBetweenDirections,this._includeSenderOfficeNum,
            this._includeSenderCellNumber,this._includeSenderEmail,this._includeDoNotCall);
    }

    switchDistBetweenStopsOnChange(event: ChangeEvent) {
        this._includeDistanceBetweenStops = this.switchDistBetweenStops.checked;
        this.handleSwitchChangeAndUpdateSmsText(this._movementId,this._includeStopDetails,this._includeArrivalTimes,
            this._includeContactInformation,this._includeCommentInformation,this._includeReferenceNumbers,
            this._includeDirections,this._includeDirectionsDisclaimer,
            this._includeDistanceBetweenStops, this._includeDistanceBetweenDirections,this._includeSenderOfficeNum,
            this._includeSenderCellNumber,this._includeSenderEmail,this._includeDoNotCall);
    }

    switchOfficePhoneOnChange(event: ChangeEvent) {
        this._includeSenderOfficeNum = this.switchOfficePhone.checked;
        this.handleSwitchChangeAndUpdateSmsText(this._movementId,this._includeStopDetails,this._includeArrivalTimes,
            this._includeContactInformation,this._includeCommentInformation,this._includeReferenceNumbers,
            this._includeDirections,this._includeDirectionsDisclaimer,
            this._includeDistanceBetweenStops, this._includeDistanceBetweenDirections,this._includeSenderOfficeNum,
            this._includeSenderCellNumber,this._includeSenderEmail,this._includeDoNotCall);
    }

    switchCellPhoneOnChange(event: ChangeEvent) {
        this._includeSenderCellNumber = this.switchCellPhone.checked;
        this.handleSwitchChangeAndUpdateSmsText(this._movementId,this._includeStopDetails,this._includeArrivalTimes,
            this._includeContactInformation,this._includeCommentInformation,this._includeReferenceNumbers,
            this._includeDirections,this._includeDirectionsDisclaimer,
            this._includeDistanceBetweenStops, this._includeDistanceBetweenDirections,this._includeSenderOfficeNum,
            this._includeSenderCellNumber,this._includeSenderEmail,this._includeDoNotCall);
    }

    switchEmailAddrOnChange(event: ChangeEvent) {
        this._includeSenderEmail = this.switchEmailAddr.checked;
        this.handleSwitchChangeAndUpdateSmsText(this._movementId,this._includeStopDetails,this._includeArrivalTimes,
            this._includeContactInformation,this._includeCommentInformation,this._includeReferenceNumbers,
            this._includeDirections,this._includeDirectionsDisclaimer,
            this._includeDistanceBetweenStops, this._includeDistanceBetweenDirections,this._includeSenderOfficeNum,
            this._includeSenderCellNumber,this._includeSenderEmail,this._includeDoNotCall);
    }

    switchDoNotCallOnChange(event: ChangeEvent) {
        this._includeDoNotCall = this.switchDoNotCall.checked;
        this.handleSwitchChangeAndUpdateSmsText(this._movementId,this._includeStopDetails,this._includeArrivalTimes,
            this._includeContactInformation,this._includeCommentInformation,this._includeReferenceNumbers,
            this._includeDirections,this._includeDirectionsDisclaimer,
            this._includeDistanceBetweenStops, this._includeDistanceBetweenDirections,this._includeSenderOfficeNum,
            this._includeSenderCellNumber,this._includeSenderEmail,this._includeDoNotCall);
    }

    updateSwitchVisibility(text: string, switchOption: Switch) {
        if (StringUtil.isEmptyString(text)) {
            switchOption.visible = false;
        }
    }

    handleSwitchChangeAndUpdateSmsText(movementId: string, includeStopDetails: boolean, includeArrivalTimes:boolean,
                                       includeContactInformation: boolean, includeComments: boolean, includeReferenceNumber: boolean,
                                       includeDirections:boolean, includeDirectionDisclaimer:boolean, includeDistanceBetweenStops:boolean,
                                       includeDistanceBetweenDirections:boolean,
                                       includeSendersOfficeNum:boolean, includeSenderCellNum:boolean, includeSendersEmail:boolean,
                                       includeDoNotCallNotice:boolean) {
        this.buildSmsMessage(movementId,includeStopDetails, includeArrivalTimes, includeContactInformation,
            includeComments,includeReferenceNumber, includeDirections,includeDirectionDisclaimer,includeDistanceBetweenStops,
            includeDistanceBetweenDirections,includeSendersOfficeNum,includeSenderCellNum, includeSendersEmail,includeDoNotCallNotice);
    }

    async buildSmsMessage(movementId: string, includeStopDetails: boolean, includeArrivalTimes: boolean,
                          includeContactInformation: boolean, includeComments: boolean, includeReferenceNumber: boolean,
                          includeDirections: boolean, includeDirectionDisclaimer: boolean, includeDistanceBetweenStops: boolean,
                          includeDistanceBetweenDirections: boolean, includeSendersOfficeNum: boolean, includeSenderCellNum: boolean,
                          includeSendersEmail: boolean, includeDoNotCallNotice: boolean) {
        const response = await Api.search("lme/powerbroker/build-sms-message",
            {
                "movement_id": movementId,
                "include_stop_details": includeStopDetails,
                "include_arrival_times": includeArrivalTimes,
                "include_contact_info": includeContactInformation,
                "include_comments": includeComments,
                "include_reference_num": includeReferenceNumber,
                "include_directions": includeDirections,
                "include_directions_disclaimer": includeDirectionDisclaimer,
                "include_distance_between_stops": includeDistanceBetweenStops,
                "include_distance_between_directions": includeDistanceBetweenDirections,
                "include_sender_office_num": includeSendersOfficeNum,
                "include_sender_cell_num": includeSenderCellNum,
                "include_sender_email": includeSendersEmail,
                "include_do_not_call": includeDoNotCallNotice
            });
        if (response.data[0] !== undefined && response.data[0]?.sms_message !== undefined) {
            this.smsMessageText.text = response.data[0].sms_message + this.appendTextStopToOptOut();
        }
    }

    appendTextStopToOptOut(): string {
        return  '\n\nText back "stop" to opt-out of future messages.';
    }

    override async onLoad(): Promise<void> {
        await this.getTemplateFieldData(this._movementId, this._orderId);
        this.addBeforeLookupModelSearchListener(this.layoutSmsFieldsContainer.textboxDriverName);
        this.layoutSmsFieldsContainer.textboxDriverName.addLookupModelSelectionListener((event: LookupModelSelectionEvent) => {
            this.handleDriverSelection.call(this, event);
        });

        this.addBeforeLookupModelSearchListener(this.layoutSmsFieldsContainerTextLocate.textboxDriverName);
        this.layoutSmsFieldsContainerTextLocate.textboxDriverName.addLookupModelSelectionListener((event: LookupModelSelectionEvent) => {
            this.handleDriverSelection.call(this, event);
        });

        this.layoutSmsFieldsContainer.addLayoutLoadListener(() => {
            if (this.layoutSmsFieldsContainer._orderId === undefined) {
                this.layoutSmsFieldsContainer._orderId = this._orderId;
            }
        });

        this.layoutSmsFieldsContainerTextLocate.addLayoutLoadListener(() => {
            if (this.layoutSmsFieldsContainerTextLocate._orderId === undefined) {
                this.layoutSmsFieldsContainerTextLocate._orderId = this._orderId;
            }
        });
    }

    private addBeforeLookupModelSearchListener(textbox) {
        textbox.addBeforeLookupModelSearchListener(event => {
            event.filter.carrier_id = this._carrierId;
            event.filter.lookup_search = true;
        });
    }
    private handleDriverSelection(event: LookupModelSelectionEvent) {
        const row = event.selection;
        if (row != null)
            this.setDefaultsViaRow(row);
    }

    private setLayoutFields(container: SmsFieldsContainer, driver_cell: string, driver_name: string, updateMessage: boolean, deliveryMode: string, hours: string, recurrenceFrequency: string, recurrenceTermination: string, orderId: string) {
        container.textboxDriverName.text = driver_name;
        container.textboxCellPhoneNumber.text = driver_cell;
        if(updateMessage){
            if(!StringUtil.isEmptyString(deliveryMode)){
                container.textboxSendMessageDeliveryMode.text = this.convertValueToDisplayMode(deliveryMode);
            }
            if(!StringUtil.isEmptyString(recurrenceFrequency)){
                container.textboxResendFrequency.text = recurrenceFrequency;
            }
            if(!StringUtil.isEmptyString(recurrenceTermination)){
                container.textboxRecurrenceTermination.text = this.convertTerminationValueToDisplayMode(recurrenceTermination);
            }
            if(!StringUtil.isEmptyString(hours)){
                container.textboxHours.text = hours;
            }
        }else {
            container.textboxSendMessageDeliveryMode.text = "Now";
        }
    }

    private convertModeValue(mode: string) {
        if(StringUtil.equalsIgnoreCase("Now",mode)){
            mode = "N";
        }else if(StringUtil.equalsIgnoreCase("Prior to pickup",mode)){
            mode = "P"
        }else if(StringUtil.equalsIgnoreCase("After pickup",mode)){
            mode = "A"
        }
        return mode;
    }

    private convertTerminationValueToDisplayMode(terminationMode: string) {
        if(StringUtil.equalsIgnoreCase("C",terminationMode)){
            terminationMode = "Consignee Arrival";
        }else if(StringUtil.equalsIgnoreCase("L",terminationMode)){
            terminationMode = "Load Delivery"
        }
        return terminationMode;
    }

    private convertValueToDisplayMode(mode: string) {
        if(StringUtil.equalsIgnoreCase("N",mode)){
            mode = "Now";
        }else if(StringUtil.equalsIgnoreCase("P",mode)){
            mode = "Prior to pickup"
        }else if(StringUtil.equalsIgnoreCase("A",mode)){
            mode = "After pickup"
        }
        return mode;
    }

    private convertRecurrenceTerminationValue(recurrenceTermination: string) {
        if(StringUtil.equalsIgnoreCase("Consignee Arrival",recurrenceTermination)){
            recurrenceTermination = "C";
        }else if(StringUtil.equalsIgnoreCase("Load Delivery",recurrenceTermination)){
            recurrenceTermination = "L"
        }
        return recurrenceTermination;
    }

    async getTemplateFieldData(_movementId: string,_orderId:string) {
        const response = await Api.search("lme/powerbroker/get-template-data", {"movement_id": _movementId, "order_id":_orderId});
        if (response.data[0] !== undefined && response.data[0]?.template_data !== undefined) {
            const templateData: SMSTemplate = response.data[0].template_data;
            this.updateSwitchVisibility(templateData.street_addresses, this.switchStopName);
            this.updateSwitchVisibility(templateData.schedule_arrival_times, this.switchSchedArrivalTimes);
            this.updateSwitchVisibility(templateData.contact_information, this.switchContactInfo);
            this.updateSwitchVisibility(templateData.comments, this.switchComments);
            this.updateSwitchVisibility(templateData.reference_numbers, this.switchReferenceNumbers);
            this.updateSwitchVisibility(templateData.directions, this.switchDirections);
            this.updateSwitchVisibility(templateData.directions_disclaimer, this.switchDirectionsDisclaimer);
            this.updateSwitchVisibility(templateData.distance_between_stops, this.switchDistBetweenStops);
            this.updateSwitchVisibility(templateData.office_phone, this.switchOfficePhone);
            this.updateSwitchVisibility(templateData.office_cell, this.switchCellPhone);
            this.updateSwitchVisibility(templateData.office_email, this.switchEmailAddr);
            this.updateSwitchVisibility(templateData.do_not_call_notice, this.switchDoNotCall);
            if (!StringUtil.isEmptyString(templateData.order_number)) {
                this.smsMessageText.text = templateData.order_number + this.appendTextStopToOptOut();
                this.labelRequestLocation.text = templateData.request_info_header + this.appendTextStopToOptOut() + '\n\n';
                this.labelLink.text = templateData.request_link;
            }
        }
    }

    private extractSmsFields() {
        const value = this.tabset1.getActiveTab();
        const isTextLocateTab = value._index === 1;
        const container = isTextLocateTab ? this.layoutSmsFieldsContainerTextLocate : this.layoutSmsFieldsContainer;
        return {
            phoneNumber: container.textboxCellPhoneNumber.text,
            messageText: isTextLocateTab ? this.labelRequestLocation.text : this.smsMessageText.text,
            driverName: container.textboxDriverName.text,
            hours: container.textboxHours.text,
            mode: this.convertModeValue(container.textboxSendMessageDeliveryMode.text),
            resendFrequency: container.textboxResendFrequency.text,
            recurrenceTermination: this.convertRecurrenceTerminationValue(container.textboxRecurrenceTermination.getDataValue()),
            requestLocationUrl: isTextLocateTab ? this.labelLink.link : null
        };
    }

    private handleSendMessageResponse(response) {
        const messageSent = response?.data?.[0]?.message_sent;
        const messageScheduled = response?.data?.[0]?.message_scheduled;
        const messageFailed = response?.data?.[0]?.message_failed;

        if (messageScheduled) {
            Toast.showSuccessToast("Message has been scheduled.", null, null, { millisUntilDismissal: 5000 });
        } else if (messageSent) {
            Toast.showSuccessToast("Message sent successfully.", null, null, { millisUntilDismissal: 5000 });
        } else {
            Snackbar.showSnackbar(messageFailed || "Failed to send message.");
        }
    }

    private handleUpdateMessageResponse(response) {
        const messageUpdated = response?.data?.[0]?.message_updated;
        const messageSent = response?.data?.[0]?.message_sent;
        if(messageSent){
            Toast.showSuccessToast("Message has been sent successfully.", null, null, { millisUntilDismissal: 5000 });
        }else if (messageUpdated && !messageSent) {
            Toast.showSuccessToast("Message has been updated successfully.", null, null, { millisUntilDismissal: 5000 });
        } else{
            Toast.showSuccessToast("Failed to update message.", null, null, { millisUntilDismissal: 5000 });
        }
    }

    private async sendSmsMessage() {
        const {
            phoneNumber,
            messageText,
            driverName,
            hours,
            mode,
            resendFrequency,
            recurrenceTermination,
            requestLocationUrl
        } = this.extractSmsFields();

        if (StringUtil.isEmptyString(driverName)) {
            Snackbar.showWarningSnackbar("Please provide a driver name.");
        } else if (StringUtil.isEmptyString(phoneNumber)) {
            Snackbar.showWarningSnackbar("Please provide a phone number.");
        } else if (StringUtil.isEmptyString(messageText)) {
            Snackbar.showWarningSnackbar("Please provide a text message.");
        } else {
            this.buttonSend.busy = true;
            try {
                const response = await Api.post("lme/powerbroker/send-sms-message", {
                    phone_number: phoneNumber,
                    message_text: messageText,
                    driver_name: driverName,
                    movement_id: this._movementId,
                    mode,
                    hours,
                    resend_frequency: resendFrequency,
                    recurrence_termination: recurrenceTermination,
                    request_location_url : requestLocationUrl,
                    message_count: this.textboxNumofTextMessages.text,
                    is_contact: this._isContact
                });
                await this.slideOut();
                this.handleSendMessageResponse(response);
            } catch (error) {
                Snackbar.showSnackbar("Failed to send message.");
            } finally {
                this.buttonSend.busy = false;
            }
        }
    }

    async updateScheduledMessage() {
        const {
            phoneNumber,
            messageText,
            driverName,
            hours,
            mode,
            resendFrequency,
            recurrenceTermination,
            requestLocationUrl
        } = this.extractSmsFields();

        if (StringUtil.isEmptyString(driverName)) {
            Snackbar.showWarningSnackbar("Please provide a driver name.");
        } else if (StringUtil.isEmptyString(phoneNumber)) {
            Snackbar.showWarningSnackbar("Please provide a phone number.");
        } else if (StringUtil.isEmptyString(messageText)) {
            Snackbar.showWarningSnackbar("Please provide a text message.");
        } else {
            this.buttonUpdate.busy = true;
            try {
                const response = await Api.post("lme/powerbroker/update-sms-message", {
                    phone_number: phoneNumber,
                    message_text: messageText,
                    driver_name: driverName,
                    movement_id: this._movementId,
                    mode,
                    hours,
                    resend_frequency: resendFrequency,
                    recurrence_termination: recurrenceTermination,
                    request_location_url: requestLocationUrl,
                    carrier_id: this._carrierId,
                    message_id: (StringUtil.isEmptyString(this._messageId) ? this.labelMessageId.text : this._messageId),
                    message_count: this.textboxNumofTextMessages.text,
                    is_contact: this._isContact
                });
                this.buttonUpdate.busy = false;
                await this.slideOut();
                this.handleUpdateMessageResponse(response);


            } catch (error) {
                Snackbar.showSnackbar("Failed to update message.");
            } finally {
                this.buttonUpdate.busy = false;
            }
        }
    }

    setDefaultsViaRow(row: ModelRow<any>) {

        this.mainDataSource?.activeRow?.setLookupModelData("driver_name", {"driver_name": row.get("driver_name")});
        this.mainDataSource?.activeRow?.setValues({"driver_name": row.get("driver_name"), "cell_phone_number": row.get("cell_phone_number") })
        this._isContact = StringUtil.equalsIgnoreCase(row.get("identifier"),"Contact");
        this.setLayoutFields(this.layoutSmsFieldsContainer, row.get("cell_phone_number"), row.get("driver_name",""), false, row.get("delivery_mode","Now"), row.get("hours"), row.get("recurrence_frequency",""), row.get("recurrence_termination",""), row.get("order_id",""));
        this.setLayoutFields(this.layoutSmsFieldsContainerTextLocate, row.get("cell_phone_number"), row.get("driver_name",""), false, row.get("delivery_mode","Now"), row.get("hours"), row.get("recurrence_frequency",""), row.get("recurrence_termination",""), row.get("order_id",""));


        if (StringUtil.equalsIgnoreCase(row.get("is_active"), "N")) {
            Snackbar.showWarningSnackbar("Driver is not active.");
            this.buttonSend.enabled = false;
            this.buttonSend.tooltip = "Driver must be active to receive SMS messages.";
        } else if (StringUtil.equalsIgnoreCase(row.get("is_sms_opted_in"), "N")) {
            Snackbar.showWarningSnackbar("Driver is opted out of SMS.");
            this.buttonSend.enabled = false;
            this.buttonSend.tooltip = "Driver must be opted in for SMS messages.";
        }else{
            this.buttonSend.enabled = true;
            this.buttonSend.tooltip = "Send SMS Message";
        }
        return true;
    }
}
